


















import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import GetAcceptLogo from '@getaccept/lib-ui/src/assets/img/getaccept-logo-small.svg';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { BrandingHelper } from '@getaccept/lib-shared/src/signing-theme/helpers/branding.helper';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import { EditDsrConstants } from '../constants/edit-dsr.constants';
import type { Conversation } from '../chat';
import { ChatHelper } from '../chat';
import { DrView } from '../types';
import NavigationItem from './NavigationItem.vue';

export default defineComponent({
  name: 'RoomNavigation',
  components: {
    NavigationItem,
    GetAcceptLogo,
  },
  props: {
    activeView: {
      required: true,
      type: String as PropType<DrView>,
    },
    logoUrl: {
      default: '',
      type: String,
    },
    userId: {
      type: String,
      default: '',
    },
    recipientId: {
      type: String,
      default: '',
    },
    conversations: {
      type: Array as PropType<Conversation[]>,
      default: () => [],
    },
    isTemplate: {
      type: Boolean,
    },
  },
  setup(props) {
    const themeLogo = computed(() =>
      BrandingHelper.getLogoUrl({ logoUrl: props.logoUrl } as SigningTheme)
    );

    const hasUnreadMessages = computed(() => {
      const unreadMessages = props.conversations.filter(conversation =>
        ChatHelper.isLastMessageUnread(conversation.messages, props.userId, props.recipientId)
      );
      return unreadMessages.length > 0;
    });

    return {
      items: EditDsrConstants.navigationItems(props.isTemplate),
      themeLogo,
      t,
      DrView,
      hasUnreadMessages,
    };
  },
});
